const accountApiUrl = () => {
	const prefix = document.querySelector('#lprefix')?.value?.replace(/^\/+|\/+$/g, '') || '';
	return `${prefix ? `/${prefix}` : ''}/api/ulaznice`;
};

const showAccountMessage = (element, message, state = 'error') => {
	if (!element) return;
	element.textContent = message;
	element.dataset.state = state;
	element.hidden = false;
	element.focus?.();
};

document.querySelectorAll('[data-account-form]').forEach((form) => {
	const message = form.querySelector('[data-account-message]');
	const submit = form.querySelector('button[type="submit"]');

	form.addEventListener('submit', async (event) => {
		event.preventDefault();
		if (form.dataset.accountForm === 'register') {
			const name = form.elements.regime?.value.trim();
			const email = form.elements.regemail?.value.trim();
			const terms = form.elements.reg_1?.checked;
			if (!name || !email || !terms) {
				showAccountMessage(message, form.dataset.requiredMessage || 'Please complete all required fields.');
				return;
			}
		}
		if (form.dataset.accountForm === 'login') {
			const email = form.elements.email?.value.trim();
			const password = form.elements.pass?.value;
			if (!email || !password) {
				showAccountMessage(message, form.dataset.requiredMessage || 'Please complete all required fields.');
				return;
			}
		}
		if (form.dataset.accountForm === 'lostpass' && !form.elements.forgotemail?.value.trim()) {
			showAccountMessage(message, form.dataset.requiredMessage || 'Please complete all required fields.');
			return;
		}
		if (form.dataset.accountForm === 'profile' && !form.querySelector('[name="regime"]')?.value.trim()) {
			showAccountMessage(message, form.dataset.requiredMessage || 'Please complete all required fields.');
			return;
		}
		if (form.dataset.accountForm === 'password') {
			const oldPassword = form.querySelector('[name="oldpass"]')?.value;
			const newPassword = form.querySelector('[name="newpass"]')?.value;
			const repeatedPassword = form.querySelector('[name="newpass2"]')?.value;
			if (!oldPassword || !newPassword || !repeatedPassword) {
				showAccountMessage(message, form.dataset.requiredMessage || 'Please complete all required fields.');
				return;
			}
		}

		const payload = Object.fromEntries(new FormData(form).entries());
		submit?.setAttribute('disabled', 'disabled');
		form.setAttribute('aria-busy', 'true');
		if (message) message.hidden = true;

		try {
			const response = await fetch(accountApiUrl(), {
				method: 'POST',
				headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
				body: JSON.stringify(payload),
			});
			const result = await response.json();
			if (!response.ok || (result.error && !result.regMsg)) {
				throw new Error(result.errorMessage || result.message || 'Unable to complete the request.');
			}
			showAccountMessage(message, result.regMsg || result.message || 'Request completed.', 'success');
			if (form.dataset.accountForm === 'login' && result.goto) {
				window.location.assign(result.goto);
				return;
			}
			if (form.dataset.accountForm === 'lostpass' && result.gotoAlt) {
				window.setTimeout(() => window.location.assign(result.gotoAlt), 10000);
			}
			if (form.dataset.accountForm === 'register' || form.dataset.accountForm === 'lostpass') form.reset();
			if (form.dataset.accountForm === 'password') {
				form.querySelector('[name="oldpass"]').value = '';
				form.querySelector('[name="newpass"]').value = '';
				form.querySelector('[name="newpass2"]').value = '';
			}
		} catch (error) {
			showAccountMessage(message, error instanceof Error ? error.message : 'Unable to complete the request.');
		} finally {
			submit?.removeAttribute('disabled');
			form.removeAttribute('aria-busy');
		}
	});
});

document.querySelectorAll('[data-forgot-dialog]').forEach((dialog) => {
	document.querySelectorAll('[data-forgot-open]').forEach((button) => button.addEventListener('click', () => {
		dialog.showModal();
		dialog.querySelector('#forgotemail')?.focus();
	}));
	dialog.querySelectorAll('[data-forgot-close]').forEach((button) => button.addEventListener('click', () => dialog.close()));
	dialog.addEventListener('click', (event) => {
		if (event.target === dialog) dialog.close();
	});
});
